import { API_URL, api } from './client';

/**
 * Immagine mostrata quando l'evento non ha una copertina (segnaposto in
 * `karaoke-app/public/assets/`).
 */
export const EVENT_IMAGE_FALLBACK = '/assets/event-image.svg';

export function fileUrl(name: string): string {
    return `${API_URL}/files/${encodeURIComponent(name)}`;
}

/** Un solo segmento dopo `files/`: è il percorso usato dal backend per gli upload. */
const API_FILE_PATH = /(?:^|\/)files\/([^/]+)$/i;

/**
 * URL assoluto della copertina di un evento (A5).
 *
 * `event_image` in database non ha un formato unico: le installazioni precedenti
 * salvavano l'URL assoluto verso il backend (`https://host:3001/files/foto.jpg`),
 * il form admin salva `/files/foto.jpg`. Usato così com'è, il percorso veniva
 * risolto sul dominio del frontend — che non serve `/files` — e la copertina
 * restava rotta (e bloccata anche dalla CSP, che consente le immagini solo da
 * `API_ORIGIN`). Qui tutti i casi vengono ricondotti a un'unica strategia.
 */
export function eventImageUrl(image?: string | null): string {
    const value = image?.trim() ?? '';
    if (value === '') return EVENT_IMAGE_FALLBACK;

    // Risorse che non passano dall'API: dati inline e asset del frontend.
    if (value.startsWith('data:') || value.startsWith('/assets/')) return value;

    // Percorso di un file caricato: qualunque origine venga salvata, il file è
    // servito dall'API configurata ora (`API_URL`). I nomi possono contenere
    // spazi (file caricati dalla vecchia installazione), quindi vengono codificati.
    const stored = value.match(API_FILE_PATH);
    if (stored) return fileUrl(stored[1]);

    // URL assoluto di un'immagine su un altro servizio: va lasciato intatto.
    if (/^[a-z][a-z0-9+.-]*:/i.test(value)) return value;

    // Solo il nome del file, con o senza slash iniziale.
    return fileUrl(value.replace(/^\/+/, ''));
}

export async function getFileList(): Promise<string[]> {
    const { data } = await api.get<{ content?: string[] }>('/files');
    return data.content ?? [];
}

export async function uploadFile(name: string, fileBlob: string) {
    const { data } = await api.post('/files/add', { name, file_blob: fileBlob });
    return data;
}

export async function deleteFile(name: string) {
    const { data } = await api.post('/files/delete', { name });
    return data;
}
